import { createAction, props } from '@ngrx/store';

import { Registration, RegistrationType } from 'app/features/manual-input-registration/models';
import { ProductBoxRegistration } from 'app/shared/components/product-box/models';
import { Container } from 'app/shared/features/container-selector/models';
import { Locations } from 'app/shared/features/location-selector/models';
import { RowRegistration } from 'app/shared/features/map-row-selector/models';
import { FeedbackModel } from 'app/shared/models/server/feedback-model';

export const initializeRegistrationStore = createAction('[Registrations] Initialize Registration Store');

export const addRegistrationForCurrentRowSelection = createAction(
    '[Registrations] Add Registration For Current Row Selection',
    props<{
        activityNumber: number;
        amountResult: number | undefined;
        batchNumber: number | undefined;
        containers: Container[];
        employeeNumberMultiUserMode: number | undefined;
        productBoxRegistrations: ProductBoxRegistration[];
        registrationType: RegistrationType;
        location: Locations | undefined;
    }>(),
);

export const addTimeRegistration = createAction(
    '[Registrations] Add Time Registration',
    props<{
        activityNumber: number | undefined;
        employeeNumber: number;
        registrationTimestamp: number;
        registrationType: RegistrationType;
    }>(),
);

export const addPackingRegistration = createAction(
    '[Registrations] Add Packing Registration',
    props<{
        activityNumber: number;
        employeeNumberMultiUserMode: number | undefined;
        batchNumber: number | undefined;
        location: Locations | undefined;
    }>(),
);

export const addRegistrationsToCache = createAction(
    '[Registrations] Add Registrations To Cache',
    props<{
        registrations: Registration[];
    }>(),
);

export const showingToastAfterRegistration = createAction(
    '[Registrations] Showing Toaster',
    props<{
        registrations: Registration[];
    }>(),
);

export const showingToastAfterRegistrationSuccess = createAction(
    '[Registrations] Showing Performance Feedback Toaster',
    props<{
        feedback: FeedbackModel;
    }>(),
);

export const sendCachedRegistrations = createAction('[Registrations] Send Cached Registrations');

export const sendCachedRegistrationsSuccess = createAction(
    '[Registrations] Send Cached Registrations Success',
    props<{ sentRegistrations: { [key: number]: Registration } }>(),
);

export const sendCachedRegistrationsFailure = createAction(
    '[Registrations] Send Cached Registrations Failure',
    props<{ errorMessage: string | undefined }>(),
);

export const rewriteServerRowRegistrationsForActivity = createAction(
    '[Registrations] Rewrite Server Row Registrations For Activity',
    props<{ activityNumber: number; rowRegistrations: RowRegistration[] }>(),
);

export const resetRegistrationState = createAction('[Registrations] Reset Registrations state');

export const monitorRowRegistrationsForActivity = createAction(
    '[Registrations] Monitor Row Registrations For Activity',
    props<{
        activityNumber: number;
    }>(),
);

export const stopMonitorRowRegistrationsForActivity = createAction(
    '[Registrations] Stop Monitor Row Registrations For Activity',
);
